import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=011333fe&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"
import style0 from "./Service.vue?vue&type=style&index=0&id=011333fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011333fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011333fe')) {
      api.createRecord('011333fe', component.options)
    } else {
      api.reload('011333fe', component.options)
    }
    module.hot.accept("./Service.vue?vue&type=template&id=011333fe&scoped=true&", function () {
      api.rerender('011333fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/Service.vue"
export default component.exports